import React from "react";
import { useState } from "react";

interface Props {
  message: string;
  children: any;
  position: string; //along with position we can add the classnames for the tooltip based on requirement
}

function Tooltip({ message, children, position }: Props) {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      {message && message.length > 0 && (
        <div
          className="relative inline-flex"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          onFocusCapture={() => setIsVisible(true)}
          onBlurCapture={() => setIsVisible(false)}
        >
          {children}
          <div
            role="tooltip"
            aria-hidden={!isVisible}
            className={`pointer-events-none absolute z-50 rounded-md px-2.5 py-1.5 text-[11px] font-medium leading-snug md:leading-none tracking-[0.01em] max-w-[calc(100vw-2rem)] whitespace-normal break-words md:max-w-none md:whitespace-nowrap text-white bg-zinc-900/95 shadow-lg shadow-black/30 ring-1 ring-white/15 backdrop-blur-sm origin-bottom transition-all duration-150 ease-out ${
              isVisible
                ? "opacity-100 scale-100 translate-y-0"
                : "opacity-0 scale-95 translate-y-1"
            } ${position}`}
          >
            {message}
          </div>
        </div>
      )}
      {!message && <>{children}</>}
    </>
  );
}

export default Tooltip;
